import { Menu } from 'antd';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import Enums from 'utils/EnumsManager';

const { ThemeTypes, ObjectTypes } = Enums;
const { Leads, Accounts, Opportunities, Reports } = ObjectTypes;

const propTypes = {
  intl: intlShape.isRequired
};

const TopNav = ({ intl, nextPath }) => {
  const { formatMessage } = intl;
  const i18n = 'global.properNouns';
  const checkMutiplePath = () => {
    let path = nextPath;
    if (nextPath.indexOf(Accounts) !== -1 && nextPath.indexOf(Opportunities) !== -1) {
      path = `/${Opportunities}`;
    }
    return path;
  };

  const nav = [
    { id: 'dashboard', href: '/dashboard', permission: PERMISSIONS.DASHBOARD },
    { id: 'leads', href: `/${Leads}`, permission: PERMISSIONS.LEADS },
    { id: 'accounts', href: `/${Accounts}`, permission: PERMISSIONS.ACCOUNTS },
    {
      id: 'opportunities',
      href: `/${Opportunities}`,
      permission: PERMISSIONS.OPPORTUNITIES
    },
    { id: 'reports', href: `/${Reports}/list`, permission: PERMISSIONS.REPORTS },
  ];

  let defaultKey = nav.find(item => nextPath.indexOf(item.href) === 0);

  // temp fix
  const pathPrefix = nextPath.split('/')[1] || '-';
  if (pathPrefix === 'reports' || pathPrefix === 'dashboards') {
    defaultKey = nav.find(n => n.id === 'reports');
  }

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      defaultSelectedKeys={defaultKey ? [defaultKey.id] : undefined}
      selectedKeys={defaultKey ? [defaultKey.id] : undefined}
    >
      {nav.map(item => {
        const key = item.id;
        const theme = ThemeTypes[key.charAt(0).toUpperCase() + key.slice(1)];
        return (
          <Menu.Item key={key} className={`${theme}-theme-menu`}>
            <Permission permission={item.permission}>
              <Link to={item.href}>
                {formatMessage({ id: `${i18n}.${key}` })}
              </Link>
            </Permission>
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

TopNav.propTypes = propTypes;
export default withRouter(injectIntl(TopNav));



// WEBPACK FOOTER //
// ./src/components/page/TopPanel/component/topStaticNav.js